import { observer } from 'mobx-react-lite'
import { type MessageFieldStore } from 'widgets/MessageField'
import { AutoContentAction } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ui/AutoContentAction/AutoContentAction'
import { type AutoControlStore } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/store/autoControlStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/styles.module.scss'

type IActionsStep3Note = {
  contentStore: MessageFieldStore
  control: AutoControlStore
}

export const ActionsStep3Note = observer(({ contentStore, control }: IActionsStep3Note) => (
  <div className={styles.actionStep}>
    <AutoContentAction
      title={'Let AI write this note'}
      questionInfoTooltip='Agent will write this note based on the conversation'
      control={control}
      contentStore={contentStore}
    />
  </div>
))
